import { ComponentStyleConfig } from "@chakra-ui/react";

export const ReiFormLabel: ComponentStyleConfig = {
  baseStyle: {
    fontFamily: "heading",
    fontSize: "sm",
    fontWeight: 600,
    letterSpacing: "0.01em",
    color: "ink.DEFAULT",
  },
};
